import React, { useContext, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Papa, { parse } from "papaparse";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../utilities/firebase/config";
import { Box, Typography } from "@mui/material";
import { textEllipses } from "../../utilities/commonStyles/commonStyles";
import { AuthContext } from "../../utilities/context/AuthContext";
import {
  getTotalStudents,
  updateStudentCount,
} from "../../utilities/const/functions";
import { useNavigate } from "react-router-dom";
// import CSV_FILE from "re2-frontend/src/utilities/MOCK_DATA.csv"
import CSV_FILE from "../../utilities/ATTENDANCE_SAMPLE_1.csv";

const BulkAttendanceDialogLargeData = ({ showBulk, handleClose }) => {
  const createAttendance = httpsCallable(functions, "createAttendance");
  const navigate = useNavigate();
  const { setLoading, loading } = useContext(AuthContext);
  const [jsonData, setJsonData] = useState([]);
  const [resJsonData, setResJsonData] = useState([]);

  const uploadBulkAttendance = async () => {
    try {
      setLoading(true);
      // console.log({ jsonData });
      if (jsonData.length < 1) {
        setLoading(false);
        return;
      }
      const res = await createAttendance(jsonData);
      // console.log({ res });
      if (!res.error) {
        window.alert("Data upload successful ");
        setResJsonData(res.data.data);
        setJsonData([]);
      } else {
        window.alert(res.message);
      }
      // console.log({ dataParsed });
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  const handleFile = async (e) => {
    const file = e.target.files[0];
    // console.log(file);
    if (file.type !== "text/csv") {
      window.alert("please upload a csv file");
      e.target.value = "";
      setJsonData([]);
      return;
    }
    let text = await file.text();
    // console.log({ text });
    const parsedData = Papa.parse(text, {
      delimiter: ",",
      header: true,
    });
    // e.target.value = null;
    // console.log(parsedData);
    // console.log(parsedData.data);
    setResJsonData([]);
    setJsonData(parsedData?.data ?? []);
  };

  return (
    <Dialog
      open={showBulk}
      onClose={() => {
        if (resJsonData.length > 0) {
          window.location.reload();
        }
        handleClose();
      }}
      fullWidth
      sx={{
        borderRadius: "200px",
      }}
      maxWidth="lg"
    >
      <DialogTitle
        sx={{ textAlign: "center", fontSize: "18px", fontWeight: 600 }}
      >
        {"Bulk Attendance Upload"}
      </DialogTitle>
      <DialogContent>
        {/* <DialogContentText id="alert-dialog-description">Bulk User Create</DialogContentText> */}
        <Box>
          <Typography>Select CSV File</Typography> <br />
          <input type={"file"} accept={"text/csv"} onChange={handleFile} />
        </Box>
        <Typography sx={{ my: 2 }}>Data Count: {jsonData?.length}</Typography>
        <Box
          sx={{ display: "flex", flexDirection: "column", overflow: "auto" }}
        >
          {(jsonData?.length != 0 || resJsonData.length !== 0) && (
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "250px repeat(6, 175px)",
                mb: 1,
                // position: "sticky",
                // top: "10px",
                // zIndex: 100,
                // background: "#FFF",
              }}
            >
              <Box sx={{ fontWeight: 600 }}>Class ID</Box>
              <Box sx={{ fontWeight: 600 }}>Student ID</Box>
              <Box sx={{ fontWeight: 600 }}>Lesson ID</Box>
              <Box sx={{ fontWeight: 600 }}>Status</Box>
              <Box sx={{ fontWeight: 600 }}>Message</Box>
              <Box sx={{ fontWeight: 600 }}>Date</Box>
            </Box>
          )}
          {/* {console.log({ resJsonData })} */}
          {resJsonData.length < 1 &&
            jsonData.map((item, index) => {
              return (
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "250px repeat(6, 175px)",
                    mb: 1,
                  }}
                >
                  <Typography sx={textEllipses}>{item?.classId}</Typography>
                  <Typography sx={textEllipses}>{item?.studentId}</Typography>
                  <Typography sx={textEllipses}>{item?.lessonId}</Typography>
                  <Typography sx={textEllipses}>
                    {item?.attendanceStatus}
                  </Typography>
                  <Typography sx={textEllipses}>{item?.message}</Typography>
                  <Typography sx={textEllipses}>{item?.date}</Typography>
                </Box>
              );
            })}
          {/* {console.log(resJsonData)} */}
          {resJsonData.length > 0 &&
            resJsonData.map((item, index) => {
              console.log(item);
              return (
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "250px repeat(6, 175px)",
                    mb: 1,
                  }}
                >
                  {/* <Typography
                    sx={{
                      ...textEllipses,
                      background: item?.error ? "red" : "green",
                    }}
                    >
                    {item?.data?.id}
                    </Typography> */}
                  <Typography sx={textEllipses}>
                    {item?.data?.classId}
                  </Typography>
                  <Typography sx={textEllipses}>
                    {item?.data?.studentId}
                  </Typography>
                  <Typography sx={textEllipses}>
                    {item?.data?.lessonId}
                  </Typography>
                  <Typography
                    sx={{
                      ...textEllipses,
                      color: item?.error ? "red" : "green",
                    }}
                  >
                    {item?.error ? "Error" : "Success"}
                  </Typography>
                  <Typography
                    sx={{
                      ...textEllipses,
                    }}
                  >
                    {item?.message}
                  </Typography>
                </Box>
              );
            })}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          disabled={loading}
          onClick={() => {
            if (resJsonData.length > 0) {
              window.location.reload();
            }
            handleClose();
          }}
        >
          Close
        </Button>
        <Button
          disabled={loading}
          onClick={() => {
            window.open(
              // "https://firebasestorage.googleapis.com/v0/b/re2-dev-380209.appspot.com/o/mockData%2FMOCK_DATA.csv?alt=media&token=42fe72bf-b3eb-4d35-89ce-e9b4c7089447",
              CSV_FILE,
              "_blank"
            );
          }}
        >
          download_sample_csv file
        </Button>
        <Button variant="contained" onClick={uploadBulkAttendance}>
          Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default BulkAttendanceDialogLargeData;
